// extracted by mini-css-extract-plugin
module.exports = {"container":"Empty_container__3qY0y","icon":"Empty_icon__16kD8","title":"Empty_title__2DSz-","description":"Empty_description__rTYrr"};